// 表格列缓存初始化
export const setStoreageColumns = (name,initColumns) => {
  const storageData = window.localStorage.getItem(name)
  let columns = null
  if(storageData && name) {
    columns = initColumns.map(i=>{
      const item = JSON.parse(storageData).filter(col => {
        const key = i.key || i.dataIndex
        return key === col.key
      })[0]
      return {...i,...item}
    })
  }
  return columns || initColumns
}

// 表格列初始化
export const setColumnsFilter = (name,initColumns) => {
  const storageData = window.localStorage.getItem(name)
  return storageData ? storageData.split(",") : initColumns;
}
export const setColumnsStrFilter = (name,initColumns) => {
  const storageData = window.localStorage.getItem(name)
  return storageData ? JSON.parse(storageData) : initColumns;
}